<template>
	<div :class="classes">
		<div
			class="initials"
			v-if="workspace.avatar === null"
		>
			{{ initials }}
		</div>
		<div class="image" v-else>
			<img
				:src="workspace.avatar"
			/>
		</div>
	</div>
</template>

<script lang="ts">
import { WorkspaceType } from '@/common/interfaces';
import { CSSClasses } from '@/common/types';
import { Vue, Component, Prop } from 'vue-facing-decorator';

export declare type HdlWorkspaceAvatarSize = 'sm' | 'md' | 'lg';

@Component
export default class WorkspaceIcon extends Vue {
	@Prop({ required: true })
	workspace: WorkspaceType

	@Prop({ default: 'md' })
	size: HdlWorkspaceAvatarSize;

	get initials(): string {
		return this.workspace.name[0].toUpperCase();
	}

	get classes(): CSSClasses {
		const result: CSSClasses = {
			'wspace-icon': true,
			[this.size]: true
		};

		return result;
	}
}
</script>

<style lang="scss">
.wspace-icon {
	> .initials {
		@apply rounded-full text-white select-none flex flex-row items-center justify-center;
		width: 24px;
		height: 24px;
		line-height: 24px;
		background-color: rgb(47, 78, 180);
	}

	&.md {
		> .image {
			width: 24px;
			height: 24px;
		}
	}

	&.sm {
		> .image {
			width: 20px;
			height: 20px;
		}
	}

	&.lg {
		> .image {
			width: 34px;
			height: 34px;
		}
	}
}
</style>
